import EventProjectUsersResetByProjectRecursive from "./project-user/reset-by-project-recursive";
import EventProjectTemplateResetByCompany from "./project-templates/reset-by-company";
import SessionCrmContact from "./crm/crm-contact";
import SessionCrmAccount from "./crm/crm-account";
import SessionProjectDelta from "./project/project-delta";
import SessionTaskDelta from "./task/delta";
import SessionTaskMove from "./task/move";
import SessionTaskNew from "./task/add";
import SessionExpenseCategoryReset from "./expense-category/reset";
import SessionEvent_CompanyDelta from "./company/delta";
import EventCompanyUsersDelete from "core/gd-session/company-user/delete";
import EventCompanyUsersNew_v2 from "core/gd-session/company-user/new_v2";
import EventCompanyUsersDelta from "./company-user/delta";
import SessionTaskDelete from "./task/delete";
import SessionTaskTagNew from "./task-tag/add";
import SessionTaskTagDelete from "./task-tag/delete";
import SessionDependencyNew from "./dependency/add";
import SessionDependencyDelete from "./dependency/delete";
import SessionMyTasksNew from "./my-tasks/new";
import SessionProjectUsersResetByCompany from "./project-user/reset-by-company";
import SessionProjectMove from "./project/project-move";
import EventPortfolioReset from "./portfolio/portfolio-reset";
import EventPortfolioNew from "./portfolio/portfolio-new";
import EventPortfolioDelta from "./portfolio/portfolio-delta";
import EventPortfolioDelete from "./portfolio/portfolio-delete";
import SessionEventDoNothing from "core/gd-session/event-do-nothing";
import SessionEventAutomation from "./automation/automation";
import SessionEventTimerTask from "./timer/task";
import SessionProjectNew from "./project/project-new";
import SessionDocumentDelta from "./document/delta"
import SessionDocumentNew from "./document/add"
import SessionDocumentDelete from "./document/delete"
import EventPinDelete from "./pin/pin-delete"
import SessionRequestFormNew from "./request-form/new"
import SessionRequestFormDelete from "./request-form/delete"
import SessionRequestFormDelta from "./request-form/delta"
import SessionExpenseDelta from "./expense/delta";
import EventProjectsNew from "./projects/new";
import SessionTaskMessageEvent from "./task-message/universal"
import SessionTimeReportEvent from "./time-report/universal"
import SessionEventReset from "./event/reset";
import SessionEventNew from "./event/new";
import SessionEventDelete from "./event/delete";
import SessionEventDelta from "./event/delta";
import SessionEventMove from "./event/move";
import SessionEventLoadOlder from "./event/load-older";
import SessionNotepadDelta from "./notepad/delta";
import SessionEvent_AutomationLimitReached from "./automation/limit-reached";
import SessionEvent_CompanySettingsReset from "./company/company-settings";
import SessionEvent_CompaniesReset from "./company/reset";
import SessionEvent_CompanyNew from "./company/company-new";
import SessionEvent_CompanyChange from "./company/company-change";
import SessionEventMeChange from "./me/me-change";
import SessionEvent_ChatRoomsReset from "./chat/chat-rooms-reset";
import SessionEvent_ChatRoomNew from "./chat/chat-room-new";
import SessionEvent_ChatMessageNew from "./chat/chat-message-new";
import SessionEvent_ChatMessageStar from "./chat/chat-message-star";
import SessionEvent_ChatMessageUnstar from "./chat/chat-message-unstar";
import SessionEvent_ChatMessageDelete from "./chat/chat-message-delete";
import SessionEvent_ChatMessageUpdate from "./chat/chat-message-update";
import SessionEvent_ChatRoomDelete from "./chat/chat-room-delete";
import SessionEvent_ChatRoomUpdate from "./chat/chat-room-update";
import SessionEvent_ChatMessageDelta from "./message-reaction/new-chat-message-reaction";
import SessionGoalEvent from "./goal/universal"
import SessionCommentEvent from "./comment/universal"
import SessionEventHourlyCostHistory from "core/gd-session/hourly-cost-history/universal";
import {EntityType} from "core/gd/const/item";
import SessionEvent_OfficesReset from "./offices/offices"
import EventProjectsSettings from "core/gd-session/project/projects-settings";
import EventCustomViewsResetByCompany from "./custom-view/reset-by-company";
import StarredResetEvent from "./starred/reset"
import SessionEvent_CustomEntityReset from "./custom-entity/reset"
import SessionEvent_OpenSystemLink from "core/gd-session/system-link/open-system-link";
import SessionSavedViewDelta from "./saved-view/saved-view";
import SessionEventDataImportProgress from "./data-import/universal";
import EventProjectsReset from "./project/projects-reset"
import EventProjectChange from "./project/project-change"
import EventProjectDelete from "./project/project-delete"
import EventPinsReset from "./pin/pins-reset";
import SessionEvent_DepartmentReset from "core/gd-session/department/reset";
import EventCompanyUsersReset from "core/gd-session/company-user/reset";
import EventCompanyUserChange from "core/gd-session/company-user/change";
import EventCompanyUsersNew from "core/gd-session/company-user/new";

const debug = {
    error: true
};

export default function SessionEventFactory(rawEvent) {

    let Event;
    // console.log("Session eventFactory", rawEvent);

    switch (rawEvent.object) {
        case EntityType.SAVED_VIEW:

            return new SessionSavedViewDelta(rawEvent)

        case EntityType.CUSTOM_ENTITY:
            // reset only
            return new SessionEvent_CustomEntityReset(rawEvent);

        case EntityType.OFFICE:
            switch (rawEvent.method) {
                case 'reset': {
                    return new SessionEvent_OfficesReset(rawEvent);
                }
            }
            break;

        case 'system-link':
            // only opens
            return new SessionEvent_OpenSystemLink(rawEvent)

        case 'notepad':
            switch (rawEvent.method) {

                case 'delta':
                    return new SessionNotepadDelta(rawEvent)
                default:
                    console.error("Error in event parsing A0394");
                    break;
            }
            break;


        case 'me':
            switch (rawEvent.method) {

                // case 'change': Event = require('./me/me-change'); break;
                case 'change': return new SessionEventMeChange(rawEvent)
                default:
                    console.error("Error in event parsing A0394");
                    break;

            }
            break;
        case 'assigned-tasks':

            switch (rawEvent.method) {
                case 'reset': Event = require('./assigned-tasks/reset'); break;
                case 'reset-upcoming': Event = require('./assigned-tasks/reset-upcoming'); break;
                case 'reset-planning': Event = require('./assigned-tasks/reset-planning'); break;
                // case 'new': Event = require('./assigned-tasks/new'); break;
                // case 'delete': Event = require('./assigned-tasks/delete'); break;
                // case 'change': Event = require('./assigned-tasks/change'); break;
            }

            break;

        // OLd uzalos' dlya notes + kakih to starih menu settings
        // case 'account-settings':
        //     switch (rawEvent.method) {
        //         case 'change': Event = require('./account-settings/reset'); break;
        //     }
        //     break;

        case 'expense':
            // switch (rawEvent.method) {
            //
            // }
            return new SessionExpenseDelta(rawEvent)

        case 'quick-notes':
            switch (rawEvent.method) {
                case 'reset': Event = require('./quick-notes/reset'); break;
            }
            break;

        case 'dashboard':
            switch (rawEvent.method) {
                case 'reset': Event = require('./dashboard/reset'); break;
            }
            break;
        case 'company':
            switch (rawEvent.method) {

                case 'reset':
                    // Event = require('./company/reset'); return new Event(rawEvent.uid,rawEvent.data);
                    return new SessionEvent_CompaniesReset(rawEvent)

                case 'delta':
                    // Event = EventCompanyDelta; break;
                    return new SessionEvent_CompanyDelta(rawEvent)

                case 'new':
                    // const EventCompanyNew = require('./company/company-new');
                    // return new EventCompanyNew(rawEvent.uid,rawEvent.data);
                    return new SessionEvent_CompanyNew(rawEvent)

                case 'change':
                    // const EventCompanyChange = require('./company/company-change');
                    // return new EventCompanyChange(rawEvent.uid,rawEvent.data);
                    return new SessionEvent_CompanyChange(rawEvent)

                default: console.log("Error in event parsing A0394"); break;

            }

            break;
        case 'company-role':
            switch (rawEvent.method) {
                case 'change': Event = require('./company-role/change'); break;
                default: console.log("Error in event parsing A03Y4"); break;
            }
            break;

        case 'user':
            switch (rawEvent.method) {
                case 'reset': Event = require('./user/reset'); break;
                case 'reset-by-company': Event = require('./user/reset'); break;
                case 'change': Event = require('./user/change'); break;
                case 'new': Event = require('./user/new'); break;
                //case 'change-personal': Event = require('./user/change-personal'); break;
                default: console.error("Error in event parsing A0394"); break;
            }
            break;
        case 'company-user':
            switch (rawEvent.method) {
                case 'change'   :
                    // Event = require('./company-user/change'); break;
                    return new EventCompanyUserChange(rawEvent)
                case 'reset'    :
                    // Event = require('core/gd-session/company-user/reset'); break;
                    return new EventCompanyUsersReset(rawEvent)

                case 'delete'   :
                    return new EventCompanyUsersDelete(rawEvent) //Event = require('./company-user/delete'); break;
                case 'new'      :
                    // Event = require('core/gd-session/company-user/new'); break;
                    return new EventCompanyUsersNew(rawEvent)
                case 'new-v2'   : return new EventCompanyUsersNew_v2(rawEvent) // nado razrulit' s companyUser.isDeleted...
                case 'delta'    : return new EventCompanyUsersDelta(rawEvent)
                //
                // case 'delta-new':       Event = EventCompanyUsersNew_v2; break;
                // case 'delta-delete':
                // case 'delta':


                default: console.error("Error in event parsing A0394"); break;
            }
            break;
        case 'company-priority':
            switch (rawEvent.method) {
                case 'reset': Event = require('./company-priority/reset'); break;
                case 'reset-by-company': Event = require('./company-priority/reset-by-company'); break;
            }
            break;
        case 'company-settings':
            switch (rawEvent.method) {
                case 'reset': return new SessionEvent_CompanySettingsReset(rawEvent)
            }
            break;
        case 'starred':
            switch (rawEvent.method) {
                case 'reset': return new StarredResetEvent(rawEvent)

                default: console.log("Error in event parsing A0294"); break;

            }
            break;
        case 'pin':
            switch (rawEvent.method) {
                case 'delete':
                    return new EventPinDelete(rawEvent)

                case 'reset':
                    return new EventPinsReset(rawEvent)

                default:
                    console.log("Error in event parsing A0294");
                    break;

            }
            break;

        case 'projects-and-users':
            switch (rawEvent.method) {
                case 'reset':
                    Event = require('./projects-and-users/reset');
                    break;
            }
            break;

        case 'timer':
            return new SessionEventTimerTask(rawEvent)

        case 'automation':
            switch (rawEvent.method) {
                case 'limit-reached':
                    return new SessionEvent_AutomationLimitReached(rawEvent)
                default:
                    return new SessionEventAutomation(rawEvent)
            }


        case 'crm-contact':
            return new SessionCrmContact(rawEvent);

        case 'crm-account':
            return new SessionCrmAccount(rawEvent);

        case 'expense-category':
            switch (rawEvent.method) {
                case 'reset':
                default:
                    return new SessionExpenseCategoryReset(rawEvent);
            }

        case 'project-template':
            switch (rawEvent.method) {
                case 'reset':
                    return new EventProjectTemplateResetByCompany(rawEvent);
            }
            break;

        case 'projects':
            switch (rawEvent.method) {
                case 'new':
                    return new EventProjectsNew(rawEvent);
                default:
                    console.log("Error in event parsing #kkd983");
                    break;

            }
            break;

        case 'project':
            switch (rawEvent.method) {

                case 'delete':
                    return new EventProjectDelete(rawEvent)

                case 'change':
                    return new EventProjectChange(rawEvent)

                case 'move':
                    return new SessionProjectMove(rawEvent)

                case 'new':
                    return new SessionProjectNew(rawEvent)

                // vot etot metod kstati po idee ne uzaetsya (!) - 'projects-and-users' is used instead
                // case 'reset':
                //     return new EventProjectsReset(rawEvent)

                case 'delta':
                    return new SessionProjectDelta(rawEvent)

                default:
                    console.log("Error in event parsing A0294");
                    break;

            }
            break;
        case 'project-settings':
            switch (rawEvent.method) {

                case 'reset':
                    return new EventProjectsSettings(rawEvent);

                default:
                    console.log("Error in event parsing project-settings", rawEvent);
                    break;
            }
            break;
        case 'project-user':
            switch (rawEvent.method) {
                case 'reset': Event = require('./project-user/reset'); break;
                // case 'reset-by-company': Event = require('./project-user/reset-by-company'); break;
                case 'reset-by-company': return new SessionProjectUsersResetByCompany(rawEvent)

                case 'reset-by-project': Event = require('./project-user/reset-by-project'); break;
                case 'reset-by-project-recursive': Event = EventProjectUsersResetByProjectRecursive; break;
                // default: console.log("Error in event parsing A0294"); break;
            }
            break;

        case 'portfolio':
            switch (rawEvent.method) {
                case 'reset'    : return new EventPortfolioReset(rawEvent)
                case 'new'      : return new EventPortfolioNew(rawEvent)
                case 'delta'    : return new EventPortfolioDelta(rawEvent)
                case 'delete'   : return new EventPortfolioDelete(rawEvent)
            }

        //case 'project-group':
        //    switch (rawEvent.method) {
        //
        //        case 'reset':
        //            const EventProjectGroupsReset = require('./project-groups/project-groups-reset');
        //            return new EventProjectGroupsReset(rawEvent.uid,rawEvent.data);
        //            break;
        //
        //        case 'reset-by-company':
        //            const EventProjectGroupsResetByCompany = require('./project-groups/project-groups-reset-by-company');
        //            return new EventProjectGroupsResetByCompany(rawEvent.uid,rawEvent.data);
        //            break;
        //
        //        default: console.log("Error in event parsing A0294"); break;
        //    }
        //    break;
        case 'department':
            switch (rawEvent.method) {

                case 'reset':
                    return new SessionEvent_DepartmentReset(rawEvent);

                case 'reset-by-company':
                    const EventDepartmentsResetByCompany = require('./department/department-reset-by-company');
                    return new EventDepartmentsResetByCompany(rawEvent.uid,rawEvent.data);

                default:
                    console.log("Error in event parsing A0294");
                    break;
            }
            break;

        case 'my-tasks':
            switch (rawEvent.method) {
                case 'new': return new SessionMyTasksNew(rawEvent);

                default: console.log("Error in event parsing myTasks", rawEvent); break;
            }
            break;

        case 'task':
            switch (rawEvent.method) {

                case 'reset':
                    // const EventTaskReset = require('./task/task-reset');
                    // return new EventTaskReset(rawEvent.uid, rawEvent.data, rawEvent.fromSID);
                    return new SessionEventDoNothing(rawEvent)

                // case 'reset-todo-list': Event = require('./task/task-reset-todo-list'); break;
                case 'reset-todo-list':
                    return new SessionEventDoNothing(rawEvent)

                case 'update-custom-field-value': Event = require('./task/task-update-custom-field-value'); break;

                case 'move'     : return new SessionTaskMove(rawEvent);
                case 'delta'    : return new SessionTaskDelta(rawEvent);
                case 'new'      : return new SessionTaskNew(rawEvent);
                case 'delete'   : return new SessionTaskDelete(rawEvent);

                default: console.log("Error in event parsing A02987"); break;
            }
            break;

        case 'task-tag':
            switch (rawEvent.method) {
                case 'new'      : return new SessionTaskTagNew(rawEvent);
                case 'delete'   : return new SessionTaskTagDelete(rawEvent);

                default: console.log("Error in event parsing 'task-tag'", rawEvent); break;
            }
            break;

        case 'task-message':
            switch (rawEvent.method) {
                case 'new'      :
                case 'delete'   :
                case 'delta'    : return new SessionTaskMessageEvent(rawEvent)

                default: console.log("Error in event parsing 'task-message'", rawEvent); break
            }
            break

        case 'dependency':
            switch (rawEvent.method) {
                case 'new'      : return new SessionDependencyNew(rawEvent);
                case 'delete'   : return new SessionDependencyDelete(rawEvent);

                default: console.log("Error in event parsing 'dependency'", rawEvent); break;
            }
            break;

        case 'document':
            switch (rawEvent.method) {
                case 'delta'    : return new SessionDocumentDelta(rawEvent)
                case 'new'      : return new SessionDocumentNew(rawEvent)
                case 'delete'   : return new SessionDocumentDelete(rawEvent)
                default         : console.log("Error in event parsing 'document'", rawEvent); break
            }
            break

        case 'my-work':
            switch (rawEvent.method) {
                case 'reset': Event = require('./my-work/reset'); break;
                case 'new': Event = require('./my-work/new'); break;
                case 'delete': Event = require('./my-work/delete'); break;
                case 'change-positions': Event = require('./my-work/change-positions'); break;
                case 'change': Event = require('./my-work/change'); break;
            }
            break;
        case 'update':
            switch (rawEvent.method) {
                // case 'reset': Event = require('./update/reset'); break; Old not updates in session anymore
                case 'new': Event = require('./update/new'); break;
            }
            break;
        case 'counter':
            switch (rawEvent.method) {
                case 'reset': Event = require('./update/counter'); break;
            }
            break;
        /*case 'project-type':
            switch (rawEvent.method) {
                case 'reset': Event = require('./project-type/reset'); break;
                case 'reset-by-company': Event = require('./project-type/reset-by-company'); break;
                case 'new': Event = require('./project-type/new'); break;
            }
            break;*/
        // a chto ento takoe ?
        case 'group-type':
            switch (rawEvent.method) {
                case 'reset': Event = require('./group-type/reset'); break;
            }
            break;
        case 'custom-view':
            switch (rawEvent.method) {
                case 'reset'    : return new EventCustomViewsResetByCompany(rawEvent)
                case 'update'   : Event = require('./custom-view/update'); break;
                case 'delete'   : Event = require('./custom-view/delete'); break;
            }
            break;
        case 'task-type':
            switch (rawEvent.method) {
                case 'reset': Event = require('./task-type/reset'); break;
                case 'reset-by-company': Event = require('./task-type/reset-by-company'); break;
                case 'new': Event = require('./task-type/new'); break;
            }
            break;
        case 'note-type':
            switch (rawEvent.method) {
                case 'reset': Event = require('./note-type/reset'); break;
                case 'reset-by-company': Event = require('./note-type/reset-by-company'); break;
                case 'new': Event = require('./note-type/new'); break;
            }
            break;
        case 'todo-list-template':
            switch (rawEvent.method) {
                case 'reset': Event = require('./todo-list-template/reset'); break;
                case 'reset-by-company': Event = require('./todo-list-template/reset-by-company'); break;
                case 'new': Event = require('./todo-list-template/new'); break;
            }
            break;
        case 'custom-field':
            switch (rawEvent.method) {
                case 'reset': Event = require('./custom-field/reset'); break;
                case 'reset-by-company': Event = require('core/gd-session/custom-field/reset-by-company'); break;
                case 'new': Event = require('./custom-field/new'); break;
            }
            break;
        case 'status':
            switch (rawEvent.method) {
                case 'reset': Event = require('./status/reset'); break;
                case 'reset-by-company': Event = require('./status/reset-by-company'); break;
                case 'new': Event = require('./status/new'); break;
            }
            break;
        // case 'favorite':
        //     switch (rawEvent.method) {
        //         case 'reset': Event = require('./favorite/reset'); break;
        //         default: console.log("Error in event parsing A0394"); break;
        //     }
        //     break;
        // case 'user-invitation':
        //     switch (rawEvent.method) {
        //         case 'reset': Event = require('./user-invitation/reset'); break;
        //         default: console.log("Error in event parsing A0394"); break;
        //     }
        //     break;
        case 'modules':
            switch (rawEvent.method) {
                case 'reset': Event = require('./modules/reset'); break;
            }
            break;
        case 'work-schedule-access':
            switch (rawEvent.method) {
                case 'reset': Event = require('./work-schedule-access/reset'); break;
            }
            break;
        case 'export-pdf':
            switch (rawEvent.method) {
                case 'result': Event = require('./export-pdf/result'); break;
            }
            break;
        case 'chat-rooms':
            switch (rawEvent.method) {
                case 'reset':           return new SessionEvent_ChatRoomsReset(rawEvent)
            }
            break;
        case 'chat-room':
            switch (rawEvent.method) {
                case 'new':             return new SessionEvent_ChatRoomNew(rawEvent);
                case 'delete':          return new SessionEvent_ChatRoomDelete(rawEvent);
                case 'update':          return new SessionEvent_ChatRoomUpdate(rawEvent);

                case 'new-message':     return new SessionEvent_ChatMessageNew(rawEvent);
                case 'message-delete':  return new SessionEvent_ChatMessageDelete(rawEvent);
                case 'message-update':  return new SessionEvent_ChatMessageUpdate(rawEvent);
                case 'message-star':    return new SessionEvent_ChatMessageStar(rawEvent);
                case 'message-unstar':  return new SessionEvent_ChatMessageUnstar(rawEvent);
            }
            break;
        case 'chat-message' :
            switch (rawEvent.method){
                case 'delta'        : return new SessionEvent_ChatMessageDelta(rawEvent)
            }
            break

        case 'event':
            switch (rawEvent.method) {
                case 'reset'        : return new SessionEventReset(rawEvent)
                case 'new'          : return new SessionEventNew(rawEvent)
                case 'delete'       : return new SessionEventDelete(rawEvent)
                case 'delta'        : return new SessionEventDelta(rawEvent)
                case 'move'         : return new SessionEventMove(rawEvent)
                // case 'update'       : Event = require('./event/update'); break;
                case 'load-older'   : return new SessionEventLoadOlder(rawEvent)
            }
            break;


        case 'meetings':
            switch (rawEvent.method) {
                case 'reset':           Event = require('../model2/meeting/session/event/reset'); break;
            }
            break;

        case 'meeting':
            switch (rawEvent.method) {
                case 'new':             Event = require('../model2/meeting/session/event/new'); break;
                case 'delete':          Event = require('../model2/meeting/session/event/delete'); break;
                case 'update':          Event = require('../model2/meeting/session/event/update'); break;
            }
            break;

        case 'note':
            switch (rawEvent.method) {
                case 'update':          Event = require('../model2/meeting/session/event/note-update'); break;
            }
            break;

        case 'reminder':
            switch (rawEvent.method) {
                case 'new':             Event = require('./reminders/event/new'); break;
                case 'delete':          Event = require('./reminders/event/delete'); break;
                case 'update':          Event = require('./reminders/event/update'); break;
                case 'reset':           Event = require('./reminders/event/reset'); break;
            }
            break;

        case 'my-work-sort':
            switch (rawEvent.method) {
                case 'change':          Event = require('./my-work/sort-positions/change-sort-positions'); break;
                case 'reset':           Event = require('./my-work/sort-positions/reset-sort-positions'); break;
            }
            break;

        case 'request-form':
            switch (rawEvent.method) {
                case 'new'      : return new SessionRequestFormNew(rawEvent)
                case 'delete'   : return new SessionRequestFormDelete(rawEvent)
                case 'delta'    : return new SessionRequestFormDelta(rawEvent)
            }
            break

        case 'time-report':
            switch (rawEvent.method) {
                case 'new'      :
                case 'delete'   :
                case 'delta'    : return new SessionTimeReportEvent(rawEvent)
            }
            break

        case 'goal':
            switch (rawEvent.method) {
                case 'new'      :
                case 'delete'   :
                case 'delta'    :
                case 'move'     : return new SessionGoalEvent(rawEvent)
            }
            break

        case 'comment':
            switch (rawEvent.method) {
                case 'new'      :
                case 'delete'   :
                case 'delta'    : return new SessionCommentEvent(rawEvent)
            }
            break

        case EntityType.HOURLY_COST_HISTORY:
            return new SessionEventHourlyCostHistory(rawEvent)

        case EntityType.DATA_IMPORT:
            return new SessionEventDataImportProgress(rawEvent)

        default:
            if (debug.error) console.error("Unknow Event $324fdsf9");
            break;
    }

    if (!Event) {
        if (debug.error) console.error("Unknown session Event",rawEvent);
        return false;
    }

    // ignore other companies
    if (gd.companyId && rawEvent.companyId && gd.companyId!==rawEvent.companyId) {
        if (debug.error) console.warn("Session event from different company -> Ignore!",rawEvent);
        return false;
    }


    return new Event(rawEvent.uid, rawEvent.data, rawEvent.fromSID, rawEvent.companyId, rawEvent);


}
